module.exports = __webpack_public_path__ + "img/slot-animation-t.ba3a5029.gif";